import React from 'react';
import classNames from 'classnames';
import { IntlShape } from 'react-intl';
import { GridColumnProps } from '../../../../../components/shared/grid/types';
import { CollapseButton } from '../../../../../components/shared/collapse-button';
import styles from '../grid.module.scss';

export const buildTemplateColumns = (columns: GridColumnProps[]): React.CSSProperties => {
    const values: string[] = [];

    columns
        .filter((column) => column.visible === undefined || column.visible)
        .forEach((column: GridColumnProps) => {
            values.push(column.flex 
                ? (typeof column.flex === 'boolean'
                    ? '1fr'
                    : `${column.flex.grow}fr`)
                : column.width ? `${column.width}px` : 'auto'
            )
        });

    return { gridTemplateColumns: values.join(' ') };
};

interface CreateHeaderCellsParams {
    visibleColumns: GridColumnProps[];
    intl: IntlShape;
    collapseLabel: string;
    isAnyRowExpanded: boolean;
    onCollapseToggle: () => void;
}

export const createHeaderCells = ({
    visibleColumns,
    intl,
    collapseLabel,
    isAnyRowExpanded,
    onCollapseToggle,
}: CreateHeaderCellsParams): React.ReactNode[] => {
    const cells: React.ReactNode[] = [];

    visibleColumns.forEach((column, index) => {
        if (column.noHeader) {
            return;
        }
        const columnLabel = column.localizationKey
            ? intl.formatMessage({ id: column.localizationKey })
            : column.field;

        if (column.isHeaderCollapseButton) {
            cells.push(
                <div
                    key={column.field ?? `column-${index}`}
                    className={classNames(styles.customHeaderCell, styles.collapseHeaderCell)}
                    style={{gridColumn: 'span 2'}}>
                    <CollapseButton
                        displayText={collapseLabel}
                        isExpanded={isAnyRowExpanded}
                        onExpandClick={onCollapseToggle}
                        containerClassName={styles.collapseButtonContainer}
                        displayTextClassName={styles.collapseButtonText}
                    />
                </div>
            );
            return;
        }

        const headerClassName = column.field === 'amount'
            ? classNames(styles.customHeaderCell, styles.headerRight)
            : styles.customHeaderCell;

        cells.push(
            <div key={column.field ?? `column-${index}`} className={headerClassName}>
                {columnLabel}
            </div>
        );
    });

    return cells;
};
